import { autorun } from 'mobx';

export default function loadSettings(appStore: any, settingsStore: any) {
  autorun(() => {
    if (appStore.isLoggedIn) {
      settingsStore.load();
    }
  });
}
